<template>

  <div class="bgaabrsearch">
    <b-container>
      <div v-cloak>
        <b-alert
            :show="showAlert"
            variant="danger"
        >
          {{ error }}
        </b-alert>
        <template v-if="authorized">

          <bga-terms-of-use></bga-terms-of-use>

          <b-form ref="abrs" @submit.prevent="updateData">

            <div class="accordion" role="tablist">

              <cm-card card-title="Type of ABR" toggle="accordion-ABRType" visible>
<!--                <b-form-select-->
<!--                    v-model="selectedABRType"-->
<!--                    :options="ABRTypes"-->
<!--                    class="mt-3"-->
<!--                    name="ABRType"-->
<!--                    size="sm"-->
<!--                    @change="onTypeChange($event)"-->
<!--                ></b-form-select>-->

                <b-form-select v-model="unconfirmedValue" :options="ABRTypes" class="mt-3" @change="showConfirmation($event)" name="ABRType" size="sm"></b-form-select>

                <div v-if="showConfirmationDialog" class="confirmation-dialog">
                  <div class="pt-2 text-danger">Changing the Type of ABR will reset all the search criteria (below) to their default values <b-link class="px-2 text-danger" @click="confirmSelection">Continue</b-link> <b-link class="px-2 text-danger" @click="cancelSelection">Cancel</b-link></div>
                </div>


              </cm-card>

              <cm-card v-if="selectedABRType !== 'Select One'" card-title="Carriers to include in search"
                       toggle="accordion-carriers">

                <b-form-checkbox
                    v-model="selectAllCarriers"
                    :indeterminate="indeterminateCarriers"
                    @change="select('selectedCarriers', selectAllCarriers, carriers, 'id', 'indeterminateCarriers')"
                >
                  {{ selectAllCarriers ? 'Unselect All' : 'Select All' }}
                </b-form-checkbox>
                <b-form-checkbox
                    v-for="carrier in carriers"
                    :key="carrier.id"
                    v-model="selectedCarriers"
                    :value="carrier.id"
                    @change="criteriaChanged = true"
                >
                  <span v-html="carrier.name"></span>
                </b-form-checkbox>
              </cm-card>

              <cm-card
                  v-if="selectedABRType === 'Chronic Illness'"
                  card-title="Illness expected to be permanent at time of claim?"
                  toggle="accordion-ABREligPerm"
              >
                <b-form-radio-group name="ABREligPerm" stacked v-model="selectedABREligPerm" @change="criteriaChanged = true">
                  <b-form-radio value="">No Preference</b-form-radio>
                  <b-form-radio value="1">Illness expected to be permanent to file claim
                  </b-form-radio>
                  <b-form-radio value="0">Illness not required to be permanent
                  </b-form-radio>
                </b-form-radio-group>
              </cm-card>

              <cm-card
                  v-if="selectedABRType !== 'Select One' && selectedABRType !== 'Terminal Illness'"
                  card-title="Elimination period(s)"
                  toggle="accordion-ABRElimPeriod"
              >
                <b-form-group>
                  <b-form-checkbox
                      v-model="selectAllABRElimPeriods"
                      :indeterminate="indeterminateABRElimPeriods"
                      @change="select('selectedABRElimPeriods', selectAllABRElimPeriods, ABRElimPeriodSearchList, 'value', 'indeterminateABRElimPeriods')"
                  >
                    {{ selectAllABRElimPeriods ? 'Unselect All' : 'Select All' }}
                  </b-form-checkbox>
                  <b-form-checkbox
                      v-for="ABRElimPeriod in ABRElimPeriodSearchList"
                      :key="ABRElimPeriod.text"
                      v-model="selectedABRElimPeriods"
                      :value="ABRElimPeriod.value"
                      @change="criteriaChanged = true"
                  >
                    {{ ABRElimPeriod.text }}
                  </b-form-checkbox>
                </b-form-group>
              </cm-card>

              <cm-card
                  v-if="selectedABRType === 'Long-Term Care'"
                  card-title="Benefit Type"
                  toggle="accordion-ABRBenefitType"
              >
                <b-form-radio-group v-model="selectedABRBenefitType" name="ABRBenefitType" stacked @change="criteriaChanged = true">
                  <b-form-radio value="">No Preference</b-form-radio>
                  <b-form-radio value="Indemnity">Indemnity</b-form-radio>
                  <b-form-radio value="Reimbursement">Reimbursement</b-form-radio>
                </b-form-radio-group>
              </cm-card>

              <cm-card
                v-if="selectedABRType !== 'Select One'"
                card-title="Product MUST be Available in the following State"
                toggle="accordion-ABRRequiredState"
              >
                <b-form-select @change="criteriaChanged = true" v-model="ABRRequiredState" :options="stateListSelectOptions" class="mt-3" name="ABRRequiredState" size="sm"></b-form-select>
              </cm-card>

              <b-form-checkbox
                  v-if="selectedABRType === 'Chronic Illness' || selectedABRType === 'Long-Term Care' || selectedABRType === 'Other'"
                  name="ABRInternational"
                  switch
                  value="1"
                  unchecked-value="0"
                  v-model="selectedABRInternational"
                  @change="criteriaChanged = true"
              >
                This ABR must be available for international clients
              </b-form-checkbox>

              <b-form-checkbox
                  v-if="selectedABRType !== 'Select One'"
                  name="ABRDateConfirmed"
                  switch
                  v-model="selectedABRDateConfirmed"
                  @change="criteriaChanged = true"
              >
                Only show ABRs verified in the last 18 months
              </b-form-checkbox>

              <div class="d-flex justify-content-between align-items-center">

                <div>
                  <b-button variant="success" @click="updateData">{{this.buttonText}}</b-button>
                  <b-button class="ml-2" variant="light" @click="clearSearch(true)" v-if="items.length > 0"  >Clear</b-button>
                </div>

                <img style="width:120px" src="https://carriermatrix.com/wp-content/uploads/Engineered-By-Simplicity.jpg"  alt="Engineered By Simplicity Group">

              </div>

            </div>
          </b-form>

        </template>
      </div>
    </b-container>
  </div>
</template>

<script>
import {bus} from "@/event-bus"
import HelperFunctions from "@/mixins/helper-functions"

export default {
  name: "BGAABESearch",
  mixins: [HelperFunctions],
  data() {
    return {
      ABRRequiredState: '',
      criteriaChanged: false,
      showConfirmationDialog: false,
      unconfirmedValue: 'Select One',
      selectedABRType: 'Select One',
      //selectedABRIssueAgeType: [],
      selectedABREligPerm: '',
      selectedABRElimPeriods: ['30', '60', '90', '120', '180', '365', '365+'],
      selectAllABRElimPeriods: true,
      indeterminateABRElimPeriods: true,
      selectedABRDateConfirmed: true,
      selectedABRBenefitType: '',
      selectedABRInternational: false,
      stateList: {
        'AL': 'Alabama',
        'AK': 'Alaska',
        'AZ': 'Arizona',
        'AR': 'Arkansas',
        'CA': 'California',
        'CO': 'Colorado',
        'CT': 'Connecticut',
        'DE': 'Delaware',
        'DC': 'District of Columbia',
        'FL': 'Florida',
        'GA': 'Georgia',
        'HI': 'Hawaii',
        'ID': 'Idaho',
        'IL': 'Illinois',
        'IN': 'Indiana',
        'IA': 'Iowa',
        'KS': 'Kansas',
        'KY': 'Kentucky',
        'LA': 'Louisiana',
        'ME': 'Maine',
        'MD': 'Maryland',
        'MA': 'Massachusetts',
        'MI': 'Michigan',
        'MN': 'Minnesota',
        'MS': 'Mississippi',
        'MO': 'Missouri',
        'MT': 'Montana',
        'NE': 'Nebraska',
        'NV': 'Nevada',
        'NH': 'New Hampshire',
        'NJ': 'New Jersey',
        'NM': 'New Mexico',
        'NY': 'New York',
        'NC': 'North Carolina',
        'ND': 'North Dakota',
        'OH': 'Ohio',
        'OK': 'Oklahoma',
        'OR': 'Oregon',
        'PA': 'Pennsylvania',
        'RI': 'Rhode Island',
        'SC': 'South Carolina',
        'SD': 'South Dakota',
        'TN': 'Tennessee',
        'TX': 'Texas',
        'UT': 'Utah',
        'VT': 'Vermont',
        'VA': 'Virginia',
        'WA': 'Washington',
        'WV': 'West Virginia',
        'WI': 'Wisconsin',
        'WY': 'Wyoming',
      },
      ABRTypes: [
        {text: 'Select One', value: 'Select One'},
        {text: 'Terminal Illness', value: 'Terminal Illness'},
        {text: 'Critical Illness/Injury or Specified Conditions', value: 'Critical Illness/Injury'},
        {text: 'Chronic Illness', value: 'Chronic Illness'},
        {text: 'Long-Term Care', value: 'Long-Term Care'},
        {text: 'Other', value: 'Other'},
      ],
      ABRElimPeriodSearchList: [
        {text: '30 days or less', value: '30'},
        {text: '31 - 60 days', value: '60'},
        {text: '61 - 90 days', value: '90'},
        {text: '91 - 120 days', value: '120'},
        {text: '121 - 180 days', value: '180'},
        {text: '181 - 365 days', value: '365'},
        {text: '366+ days', value: '365+'},
      ],
      items: [],
      carriers: [],
      fields: [
        {key: 'carrier', label: 'Carrier', formatter: value => {
            return (value ? this.getCarrierNameByID(value) : '')
          }, sortByFormatted: 'getCarrierNameByID', tdClass: 'column-width', thClass: 'column-width'},
        {key: 'name', label: 'Product', formatter: 'toText', tdClass: 'column-width', thClass: 'column-width'},
        {key: 'ABRIssueAge', label: 'Issue Age', tdClass: 'column-width', thClass: 'column-width', callback: item => {
            return (item.ABRIssueAgeLinked === 'ABR\'s Issue Age is Tied to Underlying Product' ? 'Tied to Underlying Product' : item.ABRIssueAgeMin + ' - ' + item.ABRIssueAgeMax + ', ' + item.ABRIssueAgeType)
          }
        },
        {key: 'ABRIssueAgeInfo', label: 'Issue Age Details', formatter: 'toText', tdClass: 'column-width', thClass: 'column-width'},
        {key: 'ABRUWClasses', label: 'Underwriting Classes', formatter: 'toText', tdClass: 'column-width', thClass: 'column-width'},
        {key: 'ABRChargeInfo', label: 'ABR Cost/Charge Details', formatter: 'toText', tdClass: 'column-width', thClass: 'column-width'},
        {key: 'ABREligibility', label: 'Eligibility', formatter: 'toText', tdClass: 'column-width', thClass: 'column-width'},
        {key: 'ABREligPerm', label: 'Illness must be Permanent at Claim', tdClass: 'column-width', thClass: 'column-width', formatter: value => {
            return (value ? 'Yes' : 'No')
          }
        },
        {
          key: 'ABRElimPeriod', label: 'Elimination Period', tdClass: 'column-width', thClass: 'column-width', formatter: (value, key, item) => {
            if (value) {
              if (value === 'Other') {
                return item.ABRElimPeriodOther + ' Days'
              }
              if (value.length) {
                let days = (value.length > 1 ? value.join(', ') + ' Days' : value[0] + ' Days')
                days = days.replace('None', '0')
                if (days.includes('Other')) {
                  value = value.filter((item) => item !== 'Other')
                  days = (value.length > 1 ? value.join(', ') : '')
                  days = (days.length ? days + ', ' : '') + item.ABRElimPeriodOther + ' Days'
                }
                return days
              } else {
                return ''
              }

            }

          }, callback: item => {

            if (item.ABRElimPeriod) {
              if (item.ABRElimPeriod === 'Other') {
                return item.ABRElimPeriodOther + ' Days'
              }
              if (item.ABRElimPeriod.length) {
                let days = (item.ABRElimPeriod.length > 1 ? item.ABRElimPeriod.join(', ') + ' Days' : item.ABRElimPeriod[0] + ' Days')
                days = days.replace('None', '0')
                if (days.includes('Other')) {
                  item.ABRElimPeriod = item.ABRElimPeriod.filter((i) => i !== 'Other')
                  days = (item.ABRElimPeriod.length > 1 ? item.ABRElimPeriod.join(', ') : '')
                  days = (days.length ? days + ', ' : '') + item.ABRElimPeriodOther + ' Days'
                }
                return days
              } else {
                return ''
              }

            }

          }
        },
        {key: 'ABRElimPeriodInfo', label: 'Elimination Period Details', formatter: 'toText', tdClass: 'column-width', thClass: 'column-width'},
        {key: 'ABRRecertificationReqd', label: 'Recertification Requirements; if any', formatter: 'toText', tdClass: 'column-width', thClass: 'column-width'},
        {key: 'ABRBenefitType', label: 'Benefit Type', tdClass: 'column-width', thClass: 'column-width'},
        {key: 'ABRBenefitAmount', label: 'Benefit Amount', formatter: 'toText', tdClass: 'column-width', thClass: 'column-width'},
        {key: 'ABRBenefitUses', label: 'How Benefits may be Used', formatter: 'toText', tdClass: 'column-width', thClass: 'column-width'},
        {key: 'ABRTaxQualifiedStatus', label: 'Tax Qualified Status', tdClass: 'column-width', thClass: 'column-width'},
        {key: 'ABRResidualDBInfo', label: 'Residual Death Benefit', formatter: 'toText', tdClass: 'column-width', thClass: 'column-width'},
        {key: 'ABRWaivePremOnClaim', label: 'Waiver of Charges on Claim', formatter: 'toText', tdClass: 'column-width', thClass: 'column-width'},
        {key: 'ABRStateUnavailability', label: 'Product NOT Available in These States', formatter: 'toText', tdClass: 'column-width', thClass: 'column-width'},
        {key: 'ABRStateAvailabilityDetails', label: 'Product State Availability details, if any', formatter: 'toText', tdClass: 'column-width', thClass: 'column-width'},
        {key: 'ABRAdditionalDetails', label: 'Additional Information', formatter: 'toText', tdClass: 'column-width', thClass: 'column-width'},
        {key: 'ProdLinks', label: 'Products Offering Rider', tdClass: 'column-width', thClass: 'column-width', callback: item => {
            return (item ? this.listProdsForExcel(item.ProdLinks) : '')
          },},
        {key: 'ABRInternational', label: 'International Availability', tdClass: 'column-width', thClass: 'column-width', formatter: value => {
            return (value ? 'Yes' : 'No')
          }
        },
        {key: 'ABRInternationalInfo', label: 'Conditions for International Benefits', tdClass: 'column-width', thClass: 'column-width', formatter: (value, key, item) => {
          if (item.ABRInternational)
            return value
          else
            return 'N/A'
        }, callback: item =>  {
            if (item.ABRInternational)
              return item.ABRInternationalInfo
            else
              return 'N/A'
          }
        },
        {key: 'ABRInfoLinks', label: 'Links to Additional Information', tdClass: 'column-width', thClass: 'column-width', formatter:  value => {
            return this.listLinks(value, 'url')
          },},
        {key: 'verification_date', label: 'Date Verified', tdClass: 'width-126', thClass: 'width-126', formatter: value => {
            if (value) {
              let date = new Date(value)
              return date.toLocaleDateString("en-US")
            } else {
              return ''
            }
          }
        },
      ],
    }
  },

  mounted() {
    this.fetchCarriers().catch(error => {
      console.error(error)
    })

  },

  methods: {

    updateResults() {
      bus.$emit("update-abr-results-items", this.items);
      bus.$emit("update-abr-visible-fields", this.visibleFields);
    },

    async updateData() {
      this.items = []
      this.updateResults()
      if (!this.selectedCarriers.length) {
        this.showAlert = true
        this.error = 'At least one Carrier needs to be selected'
        this.scrollToTop()
        return
      }
      const formData = new FormData(this.$refs['abrs'])
      formData.append('selected_carriers', this.selectedCarriers)
      if (this.selectedABRElimPeriods)
        formData.append('selected_ABRElimPeriods', this.selectedABRElimPeriods)
      formData.append('agency_id', this.agencyId)
      formData.append('api_key', this.apiKey)
      formData.append('site', window.location.href)
      const data = {}
      for (let [key, val] of formData.entries()) {
        Object.assign(data, {[key]: val})
      }
      const params = new URLSearchParams(data)
      const options = {
        headers: new Headers(),
      }
      this.items = await fetch(this.$hostname + '/cm_api/cm/v1/abr-api?' + params, options)
          .then(res => {
            return res.json()
          })
          .then(items => {
            return items;
          })

      if (this.items.error) {
        this.showAlert = true
        this.error = this.items.error.message
        this.query_args = this.items.error.query_args
        this.scrollToTop()
      }

      // Apply column widths from the API response
      if (this.items.length > 0 && this.items[0]._column_widths) {
        // Apply the dynamic column widths to each field
        this.visibleFields.forEach(field => {
          // Find the first item that has width information for this field
          const firstItem = this.items.find(item => item._column_widths && item._column_widths[field.key]);
          if (firstItem && firstItem._column_widths[field.key]) {
            const width = firstItem._column_widths[field.key];
            field.tdClass = `width-${width}`;
            field.thClass = `width-${width}`;
            field.thStyle = { width: `${width}px`, minWidth: `${width}px` };
            field.tdStyle = { width: `${width}px`, minWidth: `${width}px` };
          }
        });
      }

      this.updateResults()
    },

    listProdsForExcel(value) {
      if (!value && typeof value != 'object')
        return
      if (value.length) {
        return value.map(function (e) {
          return e.title
        }).join(', ')
      } else {
        return ''
      }

    },


    cancelSelection () {
      this.unconfirmedValue = this.selectedABRType
      this.showConfirmationDialog = false
    },

    confirmSelection () {
      this.showConfirmationDialog = false
      this.selectedABRType = this.unconfirmedValue
      this.onTypeChange(this.selectedABRType)
    },

    showConfirmation (value) {
      if (this.selectedABRType !== 'Select One' && this.criteriaChanged === true) {
        this.showConfirmationDialog = true
        this.unconfirmedValue = value
      } else {
        this.selectedABRType = value
        this.onTypeChange(value)
      }
    },



    clearSearch(clearType = false) {

      this.items = []
      bus.$emit("update-abr-results-items", this.items)

      if (clearType) {
        this.selectedABRType = 'Select One'
        this.unconfirmedValue = 'Select One'
      }

      this.selectedCarriers = []
      for (let key in this.carriers) {
        this.selectedCarriers.push(this.carriers[key].id)
      }
      this.selectAllCarriers = true
      this.indeterminateCarriers = true

      this.selectedABREligPerm = ''
      this.selectedABRElimPeriods = ['30', '60', '90', '120', '180', '365', '365+']
      this.selectAllABRElimPeriods = true
      this.indeterminateABRElimPeriods = true
      this.selectedABRDateConfirmed = true
      this.selectedABRBenefitType = ''
      this.selectedABRInternational = false

    },



    onTypeChange(e) {

      this.clearSearch()
      this.ABRRequiredState = '';

      switch (e) {
        case 'Terminal Illness':
          this.buildVisibleFields(['carrier', 'name', 'ABRIssueAge', 'ABRIssueAgeInfo', 'ABREligibility', 'ABRBenefitAmount', 'ABRAdditionalDetails', 'ProdLinks', 'ABRInfoLinks', 'verification_date'])
          this.selectedABRElimPeriods = []
          break
        case 'Critical Illness/Injury':
          this.buildVisibleFields(['carrier', 'name', 'ABRIssueAge', 'ABRIssueAgeInfo', 'ABRUWClasses', 'ABRChargeInfo', 'ABREligibility', 'ABRElimPeriod', 'ABRElimPeriodOther', 'ABRElimPeriodInfo', 'ABRRecertificationReqd', 'ABRBenefitAmount', 'ABRStateUnavailability', 'ABRStateAvailabilityDetails', 'ABRAdditionalDetails', 'ProdLinks', 'ABRInfoLinks', 'verification_date'])
          this.selectedABRElimPeriods = ['30', '60', '90', '120', '180', '365', '365+']
          break
        case 'Chronic Illness':
          this.buildVisibleFields(['carrier', 'name', 'ABRIssueAge', 'ABRIssueAgeInfo', 'ABRUWClasses', 'ABRChargeInfo', 'ABREligibility', 'ABREligPerm', 'ABRElimPeriod', 'ABRElimPeriodOther', 'ABRElimPeriodInfo', 'ABRRecertificationReqd', 'ABRBenefitAmount', 'ABRBenefitUses', 'ABRTaxQualifiedStatus', 'ABRResidualDBInfo', 'ABRWaivePremOnClaim', 'ABRStateUnavailability', 'ABRStateAvailabilityDetails', 'ABRAdditionalDetails', 'ABRInternational', 'ABRInternationalInfo', 'ProdLinks', 'ABRInfoLinks', 'verification_date'])
          this.selectedABRElimPeriods = ['30', '60', '90', '120', '180', '365', '365+']
          break
        case 'Long-Term Care':
          this.buildVisibleFields(['carrier', 'name', 'ABRIssueAge', 'ABRIssueAgeInfo', 'ABRUWClasses', 'ABRChargeInfo', 'ABREligibility', 'ABRElimPeriod', 'ABRElimPeriodOther', 'ABRElimPeriodInfo', 'ABRRecertificationReqd', 'ABRBenefitType', 'ABRBenefitAmount', 'ABRBenefitUses', 'ABRTaxQualifiedStatus', 'ABRResidualDBInfo', 'ABRWaivePremOnClaim', 'ABRStateUnavailability', 'ABRStateAvailabilityDetails', 'ABRAdditionalDetails', 'ABRInternational', 'ABRInternationalInfo', 'ProdLinks', 'ABRInfoLinks', 'verification_date'])
          this.selectedABRElimPeriods = ['30', '60', '90', '120', '180', '365', '365+']
          break
        case 'Other':
          this.buildVisibleFields(['carrier', 'name', 'ABRIssueAge', 'ABRIssueAgeInfo', 'ABRUWClasses', 'ABRChargeInfo', 'ABREligibility', 'ABRElimPeriod', 'ABRElimPeriodOther', 'ABRElimPeriodInfo', 'ABRRecertificationReqd', 'ABRBenefitAmount', 'ABRBenefitUses', 'ABRTaxQualifiedStatus', 'ABRResidualDBInfo', 'ABRWaivePremOnClaim', 'ABRStateUnavailability', 'ABRStateAvailabilityDetails', 'ABRAdditionalDetails', 'ABRInternational', 'ABRInternationalInfo', 'ProdLinks', 'ABRInfoLinks', 'verification_date'])
          this.selectedABRElimPeriods = ['30', '60', '90', '120', '180', '365', '365+']
          break
        default:
          this.buildVisibleFields(['carrier', 'name', 'verification_date'])
      }
      bus.$emit("update-abr-visible-fields", this.visibleFields)
    },

  },
  computed: {
    stateListSelectOptions: function() {
      return [
        { value: '', text: 'None Selected' },
        ...Object.entries(this.stateList).map(([abbreviation, fullName]) => ({ value: abbreviation, text: fullName })),
      ];
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
